import * as t from "io-ts";

export function ioTsToJsonSchema(type: t.Any): any {
  if (type === t.string) return { type: "string" };
  if (type === t.number) return { type: "number" };
  if (type === t.boolean) return { type: "boolean" };
  if (type instanceof t.ArrayType)
    return { type: "array", items: ioTsToJsonSchema(type.type) };

  if (type instanceof t.InterfaceType) {
    return {
      type: "object",
      properties: Object.fromEntries(
        Object.entries(type.props).map(([key, value]) => [
          key,
          ioTsToJsonSchema(value as t.Any)
        ])
      ),
      required: Object.keys(type.props),
      additionalProperties: false
    };
  }

  throw new Error(`Unsupported io-ts type: ${type.name}`);
}
